
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

interface CreateAccountPromptProps {
  feedbackId: string;
  candidateEmail?: string;
}

const CreateAccountPrompt = ({ feedbackId, candidateEmail }: CreateAccountPromptProps) => {
  const navigate = useNavigate();

  const handleCreateAccount = () => {
    // Rediriger vers la page d'inscription avec les infos préremplies
    navigate('/auth', { 
      state: { 
        defaultTab: 'register',
        email: candidateEmail,
        redirectAfter: `/view-feedback/${feedbackId}`
      } 
    });
  };

  return (
    <Card className="mb-6 border-yellow-200 bg-yellow-50">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Conservez votre feedback</CardTitle>
        <CardDescription>
          Créez un compte pour conserver ce feedback et recevez d'autres avis de recruteurs à l'avenir.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          En créant un compte, vous pourrez :
        </p>
        <ul className="list-disc pl-5 mt-2 text-sm text-muted-foreground">
          <li>Accéder à tous vos feedbacks en un seul endroit</li>
          <li>Suivre votre progression professionnelle</li>
          <li>Demander des feedbacks à d'autres recruteurs</li>
        </ul>
      </CardContent>
      <CardFooter>
        <Button onClick={handleCreateAccount} className="w-full">
          Créer mon compte
        </Button>
      </CardFooter>
    </Card>
  );
};

export default CreateAccountPrompt;
